import html from '../legacy/la.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function LinearAlgebra() {
  return <LegacyHtmlPage slug="la" title="Linear Algebra & Differential Equations" html={html} />;
}
